import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { BASTING_TYPES, BASTINGS } from '@nandosaus/constants';
import { partition } from 'lodash';

import { SelectedOptionsPropType } from '@components/basting-selector/prop-types';
import { BastingSelector } from '@components/basting-selector';
import { Box, Flex } from '@components/grid';
import { ChoicePropType } from '../prop-types';
import { useFeature } from '../../../../hooks/use-feature';
import { useMarket } from '../../../../hooks/use-market';

const BastingChoiceType = forwardRef(({ choice, selectedOptions, onChange }, ref) => {
  const bastingOptions = choice.optionsForPicker;
  const market = useMarket();

  const isMixedBastingEnabled = useFeature('mixed-basting');
  const isMixedMode = isMixedBastingEnabled && choice?.maximumOptionLimit > 1;

  if (isMixedMode) {
    const [[plainishOption], nonPlainBastingOptions] = partition(choice.optionsForPicker, {
      label: BASTINGS[BASTING_TYPES.PLAIN].name[market],
    });

    const handleChange = newValues => {
      const valueArray = Array.isArray(newValues) ? newValues : [newValues];
      onChange(valueArray);
    };

    return (
      <Box px={{ xs: '16px', md: '32px' }} ref={ref}>
        <BastingSelector
          bastingOptions={nonPlainBastingOptions}
          selectedOptions={selectedOptions}
          onChange={handleChange}
          isMixedMode
          maxSelection={choice.maximumOptionLimit}
          plainishOption={plainishOption}
        />
      </Box>
    );
  }

  return (
    <Flex px={{ xs: '16px', md: '32px' }} ref={ref}>
      <BastingSelector selectedOptions={selectedOptions} bastingOptions={bastingOptions} onChange={onChange} />
    </Flex>
  );
});

BastingChoiceType.propTypes = {
  choice: ChoicePropType.isRequired,
  selectedOptions: SelectedOptionsPropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

export { BastingChoiceType };
